import axios from 'axios'
import { API_ENDPOINT_BASE, ROOT, PASSENGER_TYPES } from '@/constans'
import { set } from '@/utils'
import {
  ID,
  STEP,
  SEATS,
  PASSENGERS,
  REVOCATIONS,
  ROOMING,
  RESERVATION,
  DEPARTURE,
  BUDGET,
  LOADING,
  RATE
} from '@/store/mutations'
import swal from 'sweetalert2'
import { stringify } from 'qs'

var Timer

export default {
  namespaced: true,
  state: {
    id: null,
    departure: {},
    passengers: [],
    revocations: [],
    seats: [],
    rooming: {},
    budget: {},
    rate: {},
    step: null,
    session: 901
  },
  mutations: {
    [ID]: set('id'),
    [DEPARTURE]: set('departure'),
    [RATE]: set('rate'),
    [PASSENGERS]: set('passengers'),
    [REVOCATIONS]: set('revocations'),
    [RESERVATION]: set('reservation'),
    [ROOMING]: set('rooming'),
    [BUDGET]: set('budget'),
    [SEATS]: set('seats'),
    [STEP]: set('step'),
    COUNTDOWN: set('countdown'),
    countdown (state) {
      if (state.session > 0) {
        state.session = state.session - 1
      } else {
        window.location.reload()
      }
    }
  },
  actions: {
    CLOSE ({ commit }) {
      commit(ID, null)
      commit(DEPARTURE, {})
      commit(RATE, {})
      commit(PASSENGERS, [])
      commit(REVOCATIONS, [])
      commit(SEATS, [])
      commit(ROOMING, {})
      commit(BUDGET, {})
      commit(STEP, null)
    },
    INIT ({ commit }, reservation) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios
          .post(API_ENDPOINT_BASE + '/modify/' + reservation.id)
          .then(({ data }) => {
            commit(DEPARTURE, data.departure)
            commit(RATE, data.rate)
            commit(RESERVATION, reservation)
            resolve()
          })
          .catch(() => {
            commit(ID, null)
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    BUDGETING ({ commit, state }) {
      commit(LOADING, true, ROOT)
      const { revocations, passengers, id } = state

      return new Promise((resolve, reject) => {
        const every_pax_has_seat = passengers.every(p => {
          let rtrn
          switch (p.type) {
            case PASSENGER_TYPES.infoas.str:
              rtrn = true
              break
            case PASSENGER_TYPES.infoascb.str:
              rtrn = !!p.seat_id
              break
            default:
              rtrn = p.rooming && p.seat_id
              break
          }
          return rtrn
        })

        if (every_pax_has_seat) {
          return axios
            .post(
              API_ENDPOINT_BASE + '/modify/budgeting/' + state.reservation.id,
              stringify({ revocations, passengers, id })
            )
            .then(({ data }) => {
              commit(ID, data.id)
              commit(BUDGET, data)
              resolve(data)
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => commit(LOADING, false, ROOT))
        } else {
          commit(LOADING, false, ROOT)
          resolve()
        }
      })
    },
    CONFIRM ({ commit, state }) {
      commit(LOADING, true, ROOT)
      const { revocations, passengers, id } = state

      if (Timer) {
        clearInterval(Timer)
        commit('COUNTDOWN', 901)
      }

      return new Promise((resolve, reject) => {
        return axios
          .post(
            API_ENDPOINT_BASE + '/modify/confirm/' + state.reservation.id,
            stringify({ revocations, passengers, id })
          )
          .then(({ data }) => {
            commit(ID, data.id)
            commit(BUDGET, data)
            resolve(data)
          })
          .catch(error => {
            reject(error.response.data.msg)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    NEXT ({ commit }, step) {
      commit(STEP, step)
    },
    SEATING ({ commit, state }) {
      commit(LOADING, true, ROOT)

      const { seats } = state

      return new Promise((resolve, reject) => {
        axios
          .post(
            API_ENDPOINT_BASE + '/modify/seating/' + state.reservation.id,
            stringify({ departure_id: state.departure.id, seats })
          )
          .then(({ data }) => {
            Timer = setInterval(() => commit('countdown'), 1000)
            resolve(data)
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject(error)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    }
  }
}
